// extracted by mini-css-extract-plugin
export default {"button":"Button_button__6d0Ru","small":"Button_small__yEKcg"};